import { render, staticRenderFns } from "./CPanelHostingPricing.vue?vue&type=template&id=7b91bd8e&"
import script from "./CPanelHostingPricing.vue?vue&type=script&lang=js&"
export * from "./CPanelHostingPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports